import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ModalController } from '@ionic/angular';
import { NotificationService } from '@services/notifications.service';
import { AttributeService } from '@services/attributes.service';
import { Device } from '@models/device';
import { Validators } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-user-device-attributes',
  templateUrl: './device-attributes.component.html',
  styleUrls: ['./device-attributes.component.scss']
})
export class DeviceAttributesComponent implements OnInit {
  @Input() device: Device = null;
  form = new UntypedFormGroup({
    attributes: new UntypedFormArray([])
  });
  options: any[] = [];
  isSaving: boolean = false;
  hasAttributes: boolean = false;

  constructor(
    private devicesService: AttributeService,
    private toastService: ToastService,
    private modalCtrl: ModalController,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.form.setControl('attributes', this.getMissingAttributes());
    this.form.updateValueAndValidity();
    this.form.markAsDirty();
    console.log(this.form.value, this.form.valid); // Revisa el estado inicial

  }


  closeModal() {
    this.modalCtrl.dismiss();
  }

  selectAttrOption(event, index): void {
    const selectedAttribute = event.value;
    const attributes = this.form.get('attributes') as UntypedFormArray;
    const attributeGroup = attributes.at(index) as UntypedFormGroup;
    const valueControl = attributeGroup.get('value');

    valueControl.setValue(selectedAttribute);
    valueControl.updateValueAndValidity();
    this.form.setValidators(this.alMenosUnValorSeleccionado());

    this.form.updateValueAndValidity();
  }
  alMenosUnValorSeleccionado() {
    return (formGroup: UntypedFormGroup) => {
      const attributes = formGroup.get('attributes') as UntypedFormArray;
      // Chequeamos si al menos un campo tiene valor (distinto de null y '')
      const algunoConValor = attributes.controls.some(control => {
        const value = control.get('value').value;
        return value !== null && value !== '';
      });

      return algunoConValor ? null : { sinValores: true };
    };
  }



  getMissingAttributes(): UntypedFormArray {
    if (!this.device.attributes) {
      this.device.attributes = [];
    }

    const attributes: UntypedFormArray = new UntypedFormArray([]);

    if (this.device) {
      for (const sensor of this.device.sensors) {
        if ([1, 2, 5, 11, 12, 7, 8, 16, 25, 27, 30, 38, 43].indexOf(sensor.type) > -1) {
          this.hasAttributes = true;
          console.log(this.device)
          console.log(this.device.attributes)
          let currentAttr = null;
          if (this.device.version < 4) {
            currentAttr = this.device.attributes.find(
              (a) => a.position == sensor.position && a.sensorType == sensor.type
            )
          } else {
            currentAttr = this.device.attributes.find(
              (a) => a.deviceSensorId == sensor.id && a.sensorType == sensor.type
            )
          }


          // Si el tipo es 8, añadimos el validador required 8.PulseSensor → Sensor de Pulso es obligatorio
          const isRequired = sensor.type === 8;

          const defaultOptions = this.getOptionsByDevices(sensor.type);
          const defaultValue = currentAttr
            ? currentAttr.value
            : (defaultOptions.length > 0 ? defaultOptions[0].value : null);

          const attribute = new UntypedFormGroup({
            sensorType: new UntypedFormControl(sensor.type),
            position: new UntypedFormControl(sensor.position),
            name: new UntypedFormControl(this.getAttributeName(sensor.type)),
            deviceSensorId: new UntypedFormControl(sensor.id),
            value: new UntypedFormControl(
              defaultValue,
              isRequired ? Validators.required : null
            )
          });

          attributes.push(attribute);
          this.options.push(this.getOptionsByDevices(sensor.type));
        }
      }
    }

    return attributes;
  }

  // checkValues(): boolean {
  //   for (const v of this.form.value.attributes) {
  //     if (v.value == null || v.value == '') {
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  getAttributeName(type: number) {
    let name = '';

    if ([1, 2, 5, 11, 12, 16, 25, 30, 38].indexOf(type) > -1) {
      name = 'Profundidad del sensor'
    }

    if ([7].indexOf(type) > -1) {
      name = 'Superficie del embudo';
    }

    if ([8].indexOf(type) > -1) {
      name = 'Equivalencia de pulso';
    }

    if ([27].indexOf(type) > -1) {
      name = 'Embudo o Equivalencia de pulso';
    }

    return name;
  }

  getAttributes(): UntypedFormArray {
    return this.form.get('attributes') as UntypedFormArray;
  }

  getOptionsByDevices(type: number): any {
    const options = [];

    if ([1, 2, 5, 11, 12, 16, 25, 30, 38].indexOf(type) > -1) {
      options.push({ label: '0cm', value: 0 });
      options.push({ label: '10cm', value: 10 });
      options.push({ label: '20cm', value: 20 });
      options.push({ label: '30cm', value: 30 });
      options.push({ label: '45cm', value: 45 });
      options.push({ label: '60cm', value: 60 });
      options.push({ label: '90cm', value: 90 });
      options.push({ label: '120cm', value: 120 });
      options.push({ label: '150cm', value: 150 });
      options.push({ label: '200cm', value: 200 });
    }

    if ([7].indexOf(type) > -1) {
      options.push({ label: '50cm2', value: 0.005 });
      options.push({ label: '200cm2', value: 0.02 });
    }    
    if ([8].indexOf(type) > -1) {
      options.push({ label: '1 pulso = 1 m^3', value: 1 });
      options.push({ label: '1 pulso = 10 litros', value: 0.01 });
      options.push({ label: '1 pulso = 100 litros', value: 0.1 });
      options.push({ label: '1 pulso = 1 litro', value: 0.001 });
    }

    if ([27].indexOf(type) > -1) {
      options.push({ label: 'Pluviómetro: Superficie del embudo 50cm2', value: 0.005 });
      options.push({ label: 'Pluviómetro: Superficie del embudo 200cm2', value: 0.02 });
      options.push({ label: 'Solo actúa como contador de pulso', value: 0});
      options.push({ label: 'Contador de pulso: 1 pulso = 1 m^3', value: 1 });
      options.push({ label: 'Contador de pulso: 1 pulso = 10 litros', value: 0.01 });
      options.push({ label: 'Contador de pulso: 1 pulso = 100 litros', value: 0.1 });
      options.push({ label: 'Contador de pulso: 1 pulso = 1 litro', value: 0.001 });
    }

    return options;
  }

  saveAttributes(): void {
    this.isSaving = true;
    const data = this.form.value.attributes;
    if (this.device.version >= 4) {//para guardar los attributos ordena la posición de forma correcta
      let sizeSensors = this.device.sensors.length;
      data.forEach((attr) => {
        attr.position = sizeSensors - attr.position + 1;
      })
    }
    this.devicesService.saveAttributes(this.device.id, data).subscribe(
      (response) => {
        this.confirmSave();
         this.modalCtrl.dismiss({ updated: true });
      },
      (error) => this.toastService.errorToast('Ha habido un error al guardar los datos. Inténtelo de nuevo más tarde'),
      () => this.modalCtrl.dismiss()
    )
  }

  confirmSave(): void {
    this.notificationService.removeDevice(this.device.id);
    this.toastService.successToast('Guardado correctamente');
  }
}